import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import WhyUs from "@/components/site/WhyUs";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import ServiceArea from "@/components/site/ServiceArea";
import Faq from "@/components/site/Faq";
import QuoteForm from "@/components/site/QuoteForm";
import ContactFooter from "@/components/site/ContactFooter";

export default function Landing() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);
  return (
    <div className="bg-background overflow-x-hidden" data-testid="landing-page">
      <Helmet>
        <title>Explus Cleaning LLC | House &amp; Office Cleaning in Lynnwood, Everett &amp; Edmonds, WA</title>
        <meta name="description" content="Explus Cleaning LLC provides professional house cleaning, deep cleaning, move-in/move-out, office and commercial cleaning, Airbnb turnovers and post-construction cleaning in Lynnwood, Everett, Edmonds, Mukilteo, Mill Creek, Bothell, Seattle, Bellevue and Kirkland, WA. Fully insured. Free estimates — call (253) 534-6626." />
        <link rel="canonical" href="https://www.expluscleaning.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Explus Cleaning LLC" />
        <meta property="og:title" content="Explus Cleaning LLC | House & Office Cleaning in Lynnwood, Everett & Edmonds, WA" />
        <meta property="og:description" content="Professional, fully insured house, deep, move-in/move-out, office, commercial and Airbnb cleaning across Lynnwood, Everett, Edmonds, Seattle, Bellevue, Kirkland and nearby WA cities. Free estimates." />
        <meta property="og:url" content="https://www.expluscleaning.com/" />
        <meta property="og:image" content="https://www.expluscleaning.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Explus Cleaning LLC | House & Office Cleaning in Lynnwood, Everett & Edmonds, WA" />
        <meta name="twitter:description" content="Professional, fully insured cleaning across Lynnwood, Everett, Edmonds, Seattle, Bellevue, Kirkland and nearby WA cities. Free estimates." />
        <meta name="twitter:image" content="https://www.expluscleaning.com/og-image.png" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CleaningService",
          "@id": "https://www.expluscleaning.com/#business",
          name: "Explus Cleaning LLC",
          description: "Professional house cleaning, residential and deep cleaning, move-in/move-out, office and commercial cleaning, Airbnb/turnover cleaning, post-construction cleaning, interior window cleaning, sanitizing and carpet odor removal across Snohomish and King County, WA.",
          url: "https://www.expluscleaning.com/",
          telephone: "+1-253-534-6626",
          email: "expluscleaning@gmail.com",
          image: "https://www.expluscleaning.com/og-image.png",
          logo: "https://www.expluscleaning.com/apple-touch-icon.png",
          priceRange: "$$",
          sameAs: ["https://maps.app.goo.gl/FPvY5ocQ8LQqRHab9"],
          areaServed: ["Lynnwood WA","Everett WA","Edmonds WA","Mukilteo WA","Mill Creek WA","Bothell WA","Seattle WA","Bellevue WA","Kirkland WA"],
          address: { "@type": "PostalAddress", addressLocality: "Everett", addressRegion: "WA", addressCountry: "US" },
          openingHoursSpecification: { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], opens: "08:00", closes: "18:00" },
          aggregateRating: { "@type": "AggregateRating", ratingValue: "5.0", reviewCount: "9" },
          hasOfferCatalog: { "@type": "OfferCatalog", name: "Cleaning Services", itemListElement: ["House Cleaning","Residential Cleaning","Deep Cleaning","Move-In / Move-Out Cleaning","Office Cleaning","Commercial Cleaning","Airbnb / Turnover Cleaning","Post-Construction Cleaning","Interior Window Cleaning","Sanitizing","Carpet Odor Removal"].map((n) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: n } })) }
        })}</script>
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Stats />
        <About />
        <WhyUs />
        <Gallery />
        <Reviews />
        <ServiceArea />
        <Faq />
        <QuoteForm />
        <ContactFooter />
      </main>
    </div>
  );
}
